import React, { useContext, useState, useEffect } from 'react'

import { useHistory } from 'react-router-dom'
import CustomTable from '../../product/components/molecules/CustomTable'
import CustomSearch from '../../product/components/molecules/CustomSearch'
import { useFormik } from 'formik'
import AlertContext from '../../product/context/alert/alertContext'
import { handleRedirectInternal, mapData } from '@/product/common/components'
import Layout from '@/product/components/templates/Layout'
import './ReturnLogs.css'
import SettingContext from '@/custom/context/product/productContext'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'

const ReturnLogs = (props) => {
    const alertContext = useContext(AlertContext)
    const settingcontext = useContext(SettingContext)
    const [isLoading, setIsLoading] = useState(true)

    const { searchTableFetch, search_fetch_data } = settingcontext

    const history = useHistory()
    const { setAlert } = alertContext

    const data = props.data

    const [tableBody, setTableBody] = useState([])

    const [tableAllBody, setTableAllBody] = useState({
        records: [],
        totalRecords: 0,
        setDisp: '',
    })

    const formik = useFormik({
        initialValues: {
            page: 1,
            limit: 10,
            order: '',
            orderby: 'rr.id,desc',
            primaryTable: 'return_requests',
            pick_up: '',
            filters: {
                project_id: {
                    value: data?.id || 0,
                    type: 'in',
                    field: 'rr.project_id',
                },
                user_id: {
                    value: '',
                    type: 'in',
                    field: 'rr.user_id',
                },
                admin_id: {
                    value: '',
                    type: 'in',
                    field: 'rr.admin_id',
                },
                active: {
                    value: '',
                    type: 'in',
                    field: 'rr.active',
                },
            },
        },
        onSubmit: (values) => {
            setIsLoading(true)
            searchTableFetch(values, 'returnRequests')
        },
    })

    useEffect(() => {
        setIsLoading(false)
        if (
            search_fetch_data &&
            search_fetch_data.from === 'returnRequests' &&
            search_fetch_data.records.length
        ) {
            const updatedRecords = search_fetch_data.records.map((record) => {
                let status
                if (record.active === 1 && record.admin_id > 0) {
                    status = 1
                } else if (record.active === 0 && record.admin_id > 0) {
                    status = 2
                } else if (
                    // record.active === 0 &&
                    !record.admin_id ||
                    record.admin_id === ''
                ) {
                    status = 0
                }
                return { ...record, status }
            })

            setTableBody(updatedRecords)
            setTableAllBody({
                display: search_fetch_data?.setDisp,
                totalRecords: search_fetch_data?.totalRecords,
                records: updatedRecords,
            })
            setIsLoading(false)
        } else {
            setTableBody([])
            setTableAllBody({ display: 0, totalRecords: 0, records: [] })
        }
    }, [search_fetch_data])

    const resetFrom = () => {
        formik.setValues({
            searchterm: '',
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            project_id: 0,
        })
        formik.handleReset()
        setIsLoading(false)
    }

    useEffect(() => {
        if (data.status === 'return_notes') {
            setTableBody([])
            setIsLoading(true)
            formik.values.page = 1
            formik.values.filters.project_id.value = data?.id || 0
            searchTableFetch(formik.values, 'returnRequests')
        } else {
            resetFrom()
        }
    }, [data])

    const onClickViewUser = (id, type) => {
        handleRedirectInternal(history, `users/view/${id}`)
    }

    const tableValues = [
        {
            field: 'user_id',
            type: 'hyperlink',
            clickID: 'user_id',
            onclick: onClickViewUser,
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'User ID',
        },
        {
            field: 'status',
            type: 'invoiceActive',
            // labelColorFieldCheck: 'active',
            // successColor: 'red',
            // failColor: 'green',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Status',
            // dropdownFilterBy: 'id',
            // dropdownReturnVariable: 'active',
        },
        // {
        //     field: 'users_first_name,users_last_name',
        //     type: '',
        //     firstChild: false,
        //     sort: false,
        //     disablePadding: false,
        //     label: 'Name',
        // },
        {
            field: 'return_reason',
            type: '',
            firstChild: false,
            sort: false,
            disablePadding: false,
            label: 'Return Reason',
        },
        {
            field: 'return_comments',
            type: '',
            firstChild: false,
            sort: false,
            disablePadding: false,
            label: 'Return Comments',
        },
        {
            field: 'admin_id',
            type: '',
            firstChild: false,
            sort: false,
            disablePadding: false,
            label: 'Staff ID',
        },
        {
            field: 'admin_comments',
            type: '',
            firstChild: false,
            sort: false,
            disablePadding: false,
            label: 'Staff Notes',
        },
    ]

    const searchInfo = {
        formik: formik,
        data: [
            {
                label: 'Status',
                placeholder: 'Select Status',
                class: `col-sm-4 col-12`,
                type: 'select',
                name: 'active',
                filter: true,
                options: [
                    { value: '1', show: 'Active' },
                    { value: '0', show: 'Not Active' },
                ],
                native: true,
            },
        ],
    }

    return (
        <>
            <FullScreenPopup
                modaltitle={`Return Notes`}
                open={data.status === 'return_notes' ? data.popup : false}
                handleClose={() => props.function(false)}
            >
                <div className="dashboard commentManagement">
                    {/* <CustomSearch searchInfo={searchInfo} formik={formik} /> */}
                    <CustomTable
                        formik={formik.values}
                        tableBody={tableBody}
                        tableValues={tableValues}
                        tableActions={[]}
                        allData={tableAllBody}
                        isLoading={isLoading}
                        loadingTemplate={'table'}
                        changeTableFunction={searchTableFetch}
                        fromVariable="returnRequests"
                        hideCompactView={true}
                        columnStorageVariable={'table_view_return_logs'}
                    />
                </div>
            </FullScreenPopup>
        </>
    )
}

export default ReturnLogs
